module.exports = __webpack_public_path__ + "static/img/logo_footer.fcd94276.svg";